import React from "react";
import UnitConverterApp from "./UnitConverterApp";
import "./App.css";

function App() {
  return <UnitConverterApp />;
}

export default App;
